import { defineStore } from 'pinia';

import { ClaimService } from '~/support/services';
import createBus from '~/support/utils/event-bus';

export const useClaimStore = defineStore('claims', () => {
  const config = useRuntimeConfig();
  const service = new ClaimService(config.public.gatewayBaseUrl);

  async function exportClaims(body: { storeIds: string[]; filter: { claimState: string }; timezone?: string }) {
    return service.exportClaims(body);
  }

  async function getStoreCreditUsagesByOrder(orderId: string) {
    return service.getStoreCreditUsagesByOrder(orderId);
  }

  const $bus = createBus();

  return {
    $bus,
    exportClaims,
    getStoreCreditUsagesByOrder,
  };
});
